import { OrthographicCamera as ThreeOrthographicCamera } from "three";
/**
 * Implements the IOrthographicCamera interface for ThreeJS
 */
export class OrthographicCamera extends ThreeOrthographicCamera {
    getProjectionMatrix(proj) {
        if (typeof proj !== "undefined") {
            proj.elements.length = 16;
            for (let i = 0; i < proj.elements.length; i += 1) {
                proj.elements[i] = this.projectionMatrix.elements[i];
            }
            return proj;
        }
        else {
            return this.projectionMatrix.clone();
        }
    }
    getInverseProjectionMatrix(proj) {
        if (typeof proj !== "undefined") {
            proj.elements.length = 16;
            for (let i = 0; i < proj.elements.length; i += 1) {
                proj.elements[i] = this.projectionMatrixInverse.elements[i];
            }
            return proj;
        }
        else {
            return this.projectionMatrixInverse.clone();
        }
    }
    setZoom(zoom) {
        this.zoom = Math.max(zoom, 0.25);
        this.updateProjectionMatrix();
    }
    getZoom() {
        return this.zoom;
    }
    getFrustumLeft() {
        return this.left;
    }
    getFrustumRight() {
        return this.right;
    }
    getFrustumTop() {
        return this.top;
    }
    getFrustumBottom() {
        return this.bottom;
    }
    setAspectRatio(ratio) {
        const fov = 90;
        const depth = 100;
        const orthoH = depth * 2 * Math.atan((fov * (Math.PI / 180)) / 2);
        const orthoW = orthoH * ratio;
        // Update frustum dimensions
        this.left = -orthoW / 2;
        this.right = orthoW / 2;
        this.top = orthoH / 2;
        this.bottom = -orthoH / 2;
        this.updateProjectionMatrix();
    }
}
